import {
  LayoutDashboard, Smartphone, Tv, Receipt, CreditCard, Send, Fingerprint, Landmark, Banknote, ArrowLeftRight,
  Wallet, History, FileSearch, QrCode, Globe, FileText, BarChart3, Percent, LifeBuoy, User, ShieldCheck, IdCard,
  ScrollText, Clock, Users, Network, CheckSquare, Megaphone, Ticket, Activity, BadgeCheck, Layers, Scale,
} from "lucide-react";

export const RT_NAV = [
  { group: "Main", items: [{ to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, id: "dashboard" }] },
  {
    group: "Recharge & Bills", items: [
      { to: "/recharge/mobile", label: "Mobile Recharge", icon: Smartphone, id: "mobile-recharge", svc: "recharge" },
      { to: "/recharge/dth", label: "DTH Recharge", icon: Tv, id: "dth-recharge", svc: "recharge" },
      { to: "/bbps", label: "BBPS Bill Pay", icon: Receipt, id: "bbps", svc: "bbps" },
      { to: "/credit-card", label: "Credit Card Bill", icon: CreditCard, id: "credit-card", svc: "credit_card" },
    ],
  },
  {
    group: "Money Transfer", items: [
      { to: "/dmt", label: "DMT Transfer", icon: Send, id: "dmt", svc: "dmt" },
      { to: "/pending-dmt", label: "Pending DMT", icon: Clock, id: "pending-dmt", svc: "dmt" },
    ],
  },
  {
    group: "Banking & AEPS", items: [
      { to: "/aeps", label: "AEPS Services", icon: Fingerprint, id: "aeps", svc: "aeps" },
      { to: "/aadhaar-pay", label: "Aadhaar Pay", icon: BadgeCheck, id: "aadhaar-pay", svc: "aeps" },
      { to: "/aeps/onboarding", label: "AEPS Onboard / 2FA", icon: ShieldCheck, id: "aeps-onboard", svc: "aeps" },
      { to: "/cash-deposit", label: "Cash Deposit", icon: Landmark, id: "cash-deposit", svc: "cash_deposit" },
    ],
  },
  {
    group: "Wallet & Payout", items: [
      { to: "/fund-request", label: "Fund Request", icon: Wallet, id: "fund-request", svc: "fund_request" },
      { to: "/fund-history", label: "Fund History", icon: History, id: "fund-history" },
      { to: "/move-to-bank", label: "Move to Bank", icon: Banknote, id: "move-to-bank", svc: "payout" },
      { to: "/wallet-transfer", label: "AEPS → Main Wallet", icon: ArrowLeftRight, id: "wallet-transfer", svc: "wallet_transfer" },
      { to: "/payment-gateway", label: "Payment Gateway", icon: Globe, id: "payment-gateway", svc: "pg_qr" },
      { to: "/qr-collect", label: "Collect with QR", icon: QrCode, id: "qr-collect", svc: "pg_qr" },
    ],
  },
  { group: "Verification", items: [{ to: "/pan-verify", label: "PAN Verification", icon: FileSearch, id: "pan-verify", svc: "pan" }] },
  {
    group: "Reports", items: [
      { to: "/reports/statement", label: "Statement / Ledger", icon: FileText, id: "statement" },
      { to: "/reports/recharge", label: "Recharge Report", icon: BarChart3, id: "report-recharge", svc: "recharge" },
      { to: "/reports/bbps", label: "Bill Payment Report", icon: BarChart3, id: "report-bbps", svc: "bbps" },
      { to: "/reports/dmt", label: "DMT Report", icon: BarChart3, id: "report-dmt", svc: "dmt" },
      { to: "/reports/aeps", label: "AEPS Report", icon: BarChart3, id: "report-aeps", svc: "aeps" },
      { to: "/reports/settlement", label: "Settlement Report", icon: BarChart3, id: "report-settlement" },
      { to: "/reports/move-to-bank", label: "Move to Bank Report", icon: Banknote, id: "report-payout", svc: "payout" },
      { to: "/reports/pg", label: "PG & QR Report", icon: BarChart3, id: "report-pg", svc: "pg_qr" },
      { to: "/reports/all", label: "All Services", icon: Layers, id: "report-all" },
      { to: "/commission", label: "Commission", icon: Percent, id: "commission" },
      { to: "/slabs", label: "Slab List", icon: Activity, id: "slabs" },
    ],
  },
  {
    group: "Account", items: [
      { to: "/support", label: "Support Tickets", icon: LifeBuoy, id: "support" },
      { to: "/profile", label: "My Profile", icon: User, id: "profile" },
      { to: "/kyc", label: "Update KYC", icon: ShieldCheck, id: "kyc" },
      { to: "/security", label: "Password & MPIN", icon: ShieldCheck, id: "security" },
      { to: "/id-card", label: "ID Card", icon: IdCard, id: "id-card" },
      { to: "/page/terms", label: "Terms & Policies", icon: ScrollText, id: "terms" },
    ],
  },
];

export const ADMIN_NAV = [
  {
    group: "Admin", items: [
      { to: "/admin", label: "Overview", icon: LayoutDashboard, id: "admin-overview" },
      { to: "/admin/users", label: "Retailers", icon: Users, id: "admin-users", perm: "members" },
      { to: "/admin/users/distributor", label: "Distributors", icon: Users, id: "admin-distributors", perm: "members" },
      { to: "/admin/users/super", label: "Super Distributors", icon: Users, id: "admin-supers", perm: "members" },
      { to: "/admin/users/sr", label: "Sales Reps", icon: Users, id: "admin-srs", perm: "members" },
      { to: "/admin/approvals", label: "Member Approvals", icon: CheckSquare, id: "admin-approvals", perm: "members" },
      { to: "/admin/statement", label: "Agent Statement", icon: FileText, id: "admin-statement", perm: "members" },
      { to: "/admin/fund-requests", label: "Fund Requests", icon: CheckSquare, id: "admin-funds", perm: "funds" },
      { to: "/admin/company-banks", label: "Company Banks", icon: Landmark, id: "admin-company-banks", perm: "banks" },
      { to: "/admin/services", label: "Services", icon: Layers, id: "admin-services", perm: "services" },
      { to: "/admin/charges", label: "Move to Bank Charges", icon: Banknote, id: "admin-charges", perm: "charges" },
      { to: "/admin/limits", label: "Transaction Limits", icon: ShieldCheck, id: "admin-limits", perm: "services" },
    ],
  },
  {
    group: "Reports", items: [
      { to: "/admin/transactions", label: "Transactions", icon: Activity, id: "admin-txns", perm: "reports" },
      { to: "/admin/move-to-bank", label: "Move to Bank Report", icon: Banknote, id: "admin-payout-report", perm: "reports" },
      { to: "/admin/sales-report", label: "Sales Report", icon: BarChart3, id: "admin-sales-report", perm: "reports" },
      { to: "/admin/fund-summary", label: "Fund Summary", icon: Wallet, id: "admin-fund-summary", perm: "reports" },
      { to: "/admin/callbacks", label: "Payout Callbacks", icon: Activity, id: "admin-callbacks", perm: "reports" },
      { to: "/admin/recon", label: "Reconciliation", icon: Scale, id: "admin-recon", perm: "recon" },
    ],
  },
  {
    group: "Support & Security", items: [
      { to: "/admin/tickets", label: "Ticket Desk", icon: Ticket, id: "admin-tickets", perm: "tickets" },
      { to: "/admin/news", label: "Broadcast News", icon: Megaphone, id: "admin-news", perm: "news" },
      { to: "/admin/logs", label: "Logs", icon: History, id: "admin-logs", perm: "logs" },
      { to: "/admin/subadmins", label: "Sub-Admins", icon: ShieldCheck, id: "admin-subadmins", perm: "owner" },
    ],
  },
  { group: "Account", items: [{ to: "/security", label: "Password & MPIN", icon: ShieldCheck, id: "security" }] },
];

export const adminNavFor = (user) => (user.role === "admin" ? ADMIN_NAV : ADMIN_NAV.map((g) => ({ ...g, items: g.items.filter((it) => !it.perm || (user.permissions || []).includes(it.perm)) })).filter((g) => g.items.length));

export const PANEL_NAME = { super: "Super Distributor", distributor: "Distributor", sr: "Sales Representative" };
export const NETWORK_ROLES = ["distributor", "super", "sr"];

export const dtNav = (role) => [
  {
    group: PANEL_NAME[role], items: [
      { to: "/dt", label: "Dashboard", icon: LayoutDashboard, id: "dt-dashboard" },
      { to: "/dt/retailers", label: role === "sr" ? "My Retailers" : "My Network", icon: Network, id: "dt-retailers" },
      ...(role !== "sr" ? [{ to: "/dt/sales-report", label: role === "super" ? "Sales Report DI Wise" : "Sales Report", icon: BarChart3, id: "dt-sales-report" }] : []),
    ],
  },
  {
    group: "Funds", items: [
      { to: "/dt/fund-transfer", label: "Fund Transfer", icon: ArrowLeftRight, id: "dt-fund-transfer" },
      { to: "/dt/transfer-all", label: "Fund Transfer To All", icon: Send, id: "dt-transfer-all" },
      { to: "/dt/fund-transfer?type=REVERSE", label: "Fund Revert", icon: History, id: "dt-fund-revert" },
      { to: "/dt/transfer-history", label: "Transfer History", icon: History, id: "dt-transfer-history" },
      { to: "/dt/fund-summary", label: "Fund Summary", icon: Layers, id: "dt-fund-summary" },
      { to: "/fund-request", label: "Fund Request", icon: Wallet, id: "fund-request", svc: "fund_request" },
      { to: "/fund-history", label: "Fund History", icon: History, id: "fund-history" },
    ],
  },
  {
    group: "Reports", items: [
      { to: "/reports/statement", label: "Statement", icon: FileText, id: "statement" },
      { to: "/dt/rt-statement", label: "RT Wise Statement", icon: FileText, id: "dt-rt-statement" },
      { to: "/dt/earnings", label: "Earning Report", icon: Percent, id: "dt-earnings" },
      { to: "/dt/pending-dmt", label: "Pending Transactions", icon: Clock, id: "dt-pending-dmt" },
      { to: "/dt/network-report?group=recharge", label: "Recharge Report", icon: BarChart3, id: "dt-report-recharge" },
      { to: "/dt/network-report?group=bbps", label: "Bill Payment Report", icon: BarChart3, id: "dt-report-bbps" },
      { to: "/dt/network-report?group=dmt", label: "DMT Report", icon: BarChart3, id: "dt-report-dmt" },
      { to: "/dt/network-report?group=aeps", label: "AEPS Report", icon: BarChart3, id: "dt-report-aeps" },
      { to: "/dt/move-to-bank", label: "Move to Bank Report", icon: Banknote, id: "dt-report-payout" },
      { to: "/dt/network-report", label: "All Network Report", icon: Layers, id: "dt-network-report" },
    ],
  },
  {
    group: "Account", items: [
      { to: "/support", label: "Support Tickets", icon: LifeBuoy, id: "support" },
      { to: "/profile", label: "My Profile", icon: User, id: "profile" },
      { to: "/security", label: "Change Password", icon: ShieldCheck, id: "security" },
    ],
  },
];

export const allowedNav = (nav, services) => (services ? nav.map((g) => ({ ...g, items: g.items.filter((it) => !it.svc || services[it.svc] !== false) })).filter((g) => g.items.length) : nav);

export const homeFor = (role) => (role === "admin" || role === "subadmin" ? "/admin" : NETWORK_ROLES.includes(role) ? "/dt" : "/dashboard");
